import { api } from '@/lib/api/client';
import type { GetNotificationsParams, Notification, NotificationCount } from '@shared/types/entities';

export type { Notification, NotificationCount, GetNotificationsParams } from '@shared/types/entities';

export interface NotificationListMeta {
  total: number;
  page: number;
  limit: number;
  unread: number;
}

export interface NotificationListResponse {
  data: Notification[];
  meta: NotificationListMeta;
}

// ─── API functions ────────────────────────────────────────────────────────────

export async function getNotificationCountApi(): Promise<NotificationCount> {
  return api.get('/notifications/count');
}

export async function getNotificationsApi(params?: GetNotificationsParams): Promise<NotificationListResponse> {
  const qs = new URLSearchParams();
  if (params?.page !== undefined) qs.set('page', String(params.page));
  if (params?.limit !== undefined) qs.set('limit', String(params.limit));
  if (params?.isRead !== undefined) qs.set('isRead', String(params.isRead));
  const query = qs.toString();
  return api.get(`/notifications${query ? `?${query}` : ''}`);
}

export async function markNotificationReadApi(id: number): Promise<Notification> {
  return api.patch(`/notifications/${id}/read`, {});
}

export async function markAllNotificationsReadApi(): Promise<void> {
  return api.patch('/notifications/read-all', {});
}

export async function deleteNotificationApi(id: number): Promise<void> {
  return api.delete(`/notifications/${id}`);
}
